import React, { useCallback, useContext, useEffect, useState } from "react";

import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { useParams } from "react-router-dom";

import { EvalAllFlagsResponse } from "@safetyculture/s12-apis-connect-web/s12/featureflags/v1/featureflags_pb";

import { UserUrlParamTypes } from "../../types/user-display";
import { evalAllFlags } from "api/endpoints/feature-flag-segments";
import { callOptionsHeaders } from "api/helpers";
import { FeatureFlag } from "context/feature-flags-context";
import { SnackbarContext } from "context/snackbar-context";
import { toUUID } from "helpers/s12-helpers";

const FeatureFlagsList = (props: { searchVal: string }) => {
  const { regionCode, userId } = useParams<UserUrlParamTypes>();
  const [featureFlags, setFeatureFlags] = useState<FeatureFlag>({});
  const { showError } = useContext(SnackbarContext);

  const getUserFeatureFlags = useCallback(() => {
    evalAllFlags(
      {
        userId: toUUID(userId),
      },
      callOptionsHeaders(regionCode, userId),
    )
      .then((resp: EvalAllFlagsResponse) => {
        setFeatureFlags(resp.flags);
      })
      .catch(showError);
  }, [regionCode, userId, showError]);

  useEffect(() => {
    getUserFeatureFlags();
  }, [getUserFeatureFlags]);

  const lowerSearch = props.searchVal.toLowerCase();

  return (
    <>
      <List>
        {Object.entries(featureFlags).map(([key, indeterminateFlag]) => {
          return (
            <ListItem
              key={key}
              style={{
                display:
                  lowerSearch === "" ||
                  key.toLowerCase().indexOf(lowerSearch) > -1
                    ? ""
                    : "none",
              }}
            >
              <ListItemIcon>
                {indeterminateFlag.value.value ? (
                  <CheckCircleIcon color="primary" />
                ) : (
                  <CancelIcon color="error" />
                )}
              </ListItemIcon>
              <ListItemText
                primary={
                  <>
                    <b>{key}:</b> {indeterminateFlag.value.value?.toString()}
                  </>
                }
              />
            </ListItem>
          );
        })}
      </List>
    </>
  );
};
export default FeatureFlagsList;
